type LocalStorageSchema = {
  isBlur: 'true' | 'false';
  VirtualBackground: string;
  roomId: string;
  companyId: string;
};
type LocalStorageKey = keyof LocalStorageSchema;
export const setLocalStorage = <K extends LocalStorageKey>(key: K, value: LocalStorageSchema[K]) => {
  localStorage.setItem(key, value);
};
export const getLocalStorage = (key: LocalStorageKey): string => {
  return localStorage.getItem(key) ?? '';
};
